import { FaFacebook, FaTwitter, FaLinkedin, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { useState } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig"; // Ensure your Firebase config and initialization is correct

function Footer() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubscribe = async () => {
    if (!validateEmail(email)) {
      setMessage("Please enter a valid email address.");
      setShowPopup(true);
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "emaillist"), { email });
      setMessage("Subscription successful!");
    } catch (error) {
      setMessage("Failed to subscribe. Please try again.");
    } finally {
      setIsSubmitting(false);
      setShowPopup(true);
    }
  };

  return (
    <section className="bg-light2 dark:bg-dark2 pt-4">
      <div className="Footer-div flex flex-col lg:flex-row lg:justify-around items-start lg:items-center space-y-10 mx-2 my-4 md:m-4 m:p-8 lg:p-2 text-gray-300 dark:text-gray-300">
        <div className="text-left">
          <h2 className="font-bold text-2xl text-dark0">Stay updated with our pricing list</h2>
          <div className="bg-white flex justify-between items-center my-8 rounded-lg">
            <FaEnvelope className="text-gray-600 mx-1 lg:ml-2" />
            <input
              type="text"
              value={email}
              onChange={handleInputChange}
              className="w-40 md:w-56 h-8 text-black outline-none"
              placeholder="Enter email"
            />
            <button
              onClick={handleSubscribe}
              disabled={!email.trim() || isSubmitting}
              className={`btn ml-0 mr-0 ${
                email.trim()
                  ? "opacity-100 cursor-pointer"
                  : "opacity-50 cursor-not-allowed"
              }`}
            >
              {isSubmitting ? (
                <span className="animate-spin">🔄</span>
              ) : (
                "Subscribe"
              )}
            </button>
          </div>
          <div className="footer-socials flex flex-col space-y-4">
            <h2 className="text-2xl text-dark0 font-bold">Connect with Us:</h2>
            <div className="flex space-x-8">
              <a href="#!">
                <div className="bg-dark2 hover:text-primary flex justify-center items-center h-8 w-8 rounded-full">
                  <FaFacebook />
                </div>
              </a>
              <a href="#!">
                <div className="bg-dark2 hover:text-primary flex justify-center items-center h-8 w-8 rounded-full">
                  <FaTwitter />
                </div>
              </a>
              <a href="#!">
                <div className="bg-dark2 hover:text-primary flex justify-center items-center h-8 w-8 rounded-full">
                  <FaLinkedin />
                </div>
              </a>
              <a href="#!">
                <div className="bg-dark2 hover:text-primary flex justify-center items-center h-8 w-8 rounded-full">
                  <FaWhatsapp />
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-nav">
          <h2 className="footer-h2-nav font-bold mb-4 text-2xl text-dark0">Quick Nav</h2>
          <ul className="footer-nav-items text-left text-dark0">
            <li>
              <a href="#hero-section" className="hover:text-primary p-2">
                Home
              </a>
            </li>
            <li>
              <a href="#feature-section" className="hover:text-primary p-2">
                Features
              </a>
            </li>
            <li>
              <a href="#pricing-section" className="hover:text-primary p-2">
                Pricing
              </a>
            </li>
            <li>
              <a href="#faq-section" className="hover:text-primary p-2">
                Faq
              </a>
            </li>
            <li>
              <a href="#about-section" className="hover:text-primary p-2">
                About
              </a>
            </li>
            <li>
              <a href="#contact-section" className="hover:text-primary p-2">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="py-4 text-dark0">All right reserved, JcoteckVTU @2024</div>

      {/* Popup for messages */}
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded shadow-lg text-center">
            <p>{message}</p>
            <button
              className="mt-4 px-4 py-2 bg-primary  rounded"
              onClick={() => setShowPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Footer;
